export function createRoute(route: string, params: [string, any][] = []) {
  params.forEach((param) => {
    route = route.replace(`:${param[0]}`, param[1]);
  });
  return route;
}
